import { Component, OnInit, OnDestroy } from '@angular/core';
import { GlobalService } from '../model/global.service';



@Component({
  selector: 'app-thankyou',
  templateUrl: './thankYou.html'
})
export class ThankYou implements OnInit, OnDestroy {

  constructor(private _globalService: GlobalService) {

  }
  public ngOnInit() {
    // this._activatedRoute.params.subscribe(params => {

    // });
  }


  public ngOnDestroy() {
    this._globalService.customerID = '';  
    console.log("Global CustomerID::" , this._globalService.customerID);
  }


}



// WEBPACK FOOTER //
// ./src/app/thankYou/thankYou.ts